import axios from 'axios';

const KEY_USER_TOKEN = 'kidj_ut';
const baseUrl = process.env.VUE_APP_NEW_API_BASE_URL;
const apiPrefix = process.env.VUE_APP_NEW_API_PREFIX;
const updatedApiPrefix = process.env.VUE_WEB_APP_USER_PREFIX || '/v5';

export default {
  generateRedirectKey(token) {
    var auth = {
      headers: { Authorization: 'Bearer ' + token },
    };
    return axios.get(baseUrl + apiPrefix + '/users/redirect/generate-key', auth);
  },
  getUserInfo(token) {
    const auth = {
      headers: { Authorization: 'Bearer ' + token },
    };

    return axios.get(baseUrl + updatedApiPrefix + '/users/info', auth);
  },
  updateUserConsent(token, data) {
    const auth = {
      headers: { Authorization: 'Bearer ' + token },
    };

    return axios.post(baseUrl + updatedApiPrefix + '/updateUserConsent', data, auth);
  },
  signUserOut(token) {
    const auth = {
      headers: { Authorization: 'Bearer ' + token },
    };

    return axios.delete(baseUrl + apiPrefix + '/users/signout', auth);
  },
  verifyKey(key) {
    return axios.get(baseUrl + apiPrefix + '/users/redirect/verify-key?redirectKey=' + key);
  },
  getSubscriptionList(token) {
    return axios.get(baseUrl + apiPrefix + `/subscriptions?userAlias=${token}`);
  },
};

